//libs
import {
  ArrowRightIcon,
  AtSymbolIcon,
  BellAlertIcon,
  HeartIcon,
  MagnifyingGlassIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";
//components
import Container from "components/Container";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";

const features = [
  {
    id: 1,
    title: "Tenders & RFQs",
    desc: "Easily search and filter through both large tenders and small projects like RFQs",
    icon: <MagnifyingGlassIcon className="size-6" />,
  },
  {
    id: 2,
    title: "Easy Bid Submission",
    desc: "Submit bids securely for tenders and RFQs with step-by-step guidance.",
    icon: <AtSymbolIcon className="size-6" />,
  },
  {
    id: 3,
    title: "Supplier Management",
    desc: "Manage your company profile, documents, and compliance details in one place for buyers.",
    icon: <UserGroupIcon className="size-6" />,
  },
  {
    id: 4,
    title: "Notifications & Alerts",
    desc: "Solve a problem or close a sale in real-time with chat. If no one is available, customers are seamlessly routed to email without confusion.",
    icon: <BellAlertIcon className="size-6" />,
  },
  {
    id: 5,
    title: "Collaboration Tools",
    desc: "Built-in tools to communicate and collaborate with procurement officers during the bidding and evaluation process.",
    icon: <MagnifyingGlassIcon className="size-6" />,
  },
  {
    id: 6,
    title: "Simple yet powerful",
    desc: "Simplifies procurement for small projects, reduces costs and administrative burden, and provides opportunities for smaller suppliers to participate.",
    icon: <HeartIcon className="size-6" />,
  },
];

export default function PrimaryFeatures() {
  return (
    <Container className="bg-white relative z-10 rounded-md">
      <div className="mx-auto max-w-6xl px-6 py-16 sm:py-24 lg:px-8">
        <div className="text-center">
          <p className="text-blue-500 font-bold text-lg">Features</p>
          <h2 className="text-2xl font-bold leading-10 tracking-tight text-gray-900">
            Key Features of Promethia
          </h2>
        </div>
        <div className="mt-10">
          <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-10 sm:space-y-0 lg:grid-cols-3 lg:gap-x-4">
            {features.map((row) => (
              <div key={row.id} className="flex items-center flex-col">
                <span className="size-10 mb-2 flex items-center justify-center border rounded-lg">
                  {row.icon}
                </span>
                <dt className="text-base font-semibold text-gray-900">
                  {row.title}
                </dt>
                <dd className="text-base text-gray-600 text-center">
                  {row.desc}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
      <div>
        <div class="flex-col justify-center items-center gap-4 flex">
          <div class="px-3 py-1 bg-[#eff4ff] rounded-full border border-[#b2cbff] justify-start items-center inline-flex">
            <div class="text-center text-[#004eea] text-sm font-medium leading-tight">
              Features
            </div>
          </div>
          <div class="text-center text-[#181d27] text-4xl font-bold leading-[44px]">
            How it works
          </div>
        </div>
        <TabGroup>
          <div className="w-[600px] max-w-full mx-auto my-8 border-4 border-black shadow-lg rounded-xl overflow-hidden">
            <TabPanels>
              <TabPanel key={"hiw-tab-1"}>
                <img src="/hiw.jpg" alt="How it works" />
              </TabPanel>
              <TabPanel key={"hiw-tab-2"}>
                <img src="/hiw.jpg" alt="How it works" />
              </TabPanel>
              <TabPanel key={"hiw-tab-3"}>
                <img src="/hiw.jpg" alt="How it works" />
              </TabPanel>
            </TabPanels>
          </div>
          <TabList className="grid grid-cols-3 items-start">
            <Tab
              key={"hiw-tab-1"}
              className="data-[selected]:border-t-2 data-[selected]:border-blue-500 pt-4 outline-none border-t-2 px-2"
            >
              <div class="text-center text-[#181d27] text-xl font-bold leading-[30px] mb-2">
                Search for Tenders and Quotations
              </div>
              <div class="text-center text-[#535861] text-base font-normal leading-normal">
                Suppliers can browse a list of active tenders and RFQs, using
                filters to find projects that match their expertise and
                interests.
              </div>
            </Tab>
            <Tab
              key={"hiw-tab-2"}
              className="data-[selected]:border-t-2 data-[selected]:border-blue-500 pt-4 outline-none border-t-2 px-2"
            >
              <div class="text-center text-[#181d27] text-xl font-bold leading-[30px] mb-2">
                Submit Bids
              </div>
              <div class="text-center text-[#535861] text-base font-normal leading-normal">
                Once a suitable tender or RFQ is identified, suppliers can
                submit their bids through an easy-to-follow process. This
                includes providing itemized pricing, uploading required
                documents, and confirming compliance with the tender or RFQ
                requirements.
              </div>
            </Tab>
            <Tab
              key={"hiw-tab-3"}
              className="data-[selected]:border-t-2 data-[selected]:border-blue-500 pt-4 outline-none border-t-2 px-2"
            >
              <div class="text-center text-[#181d27] text-xl font-bold leading-[30px] mb-2">
                Receive Awards
              </div>
              <div class="text-center text-[#535861] text-base font-normal leading-normal">
                After bid evaluation, suppliers are notified of the outcomes. If
                successful, they receive the award, and the system provides the
                next steps, including contract details and timelines.
              </div>
            </Tab>
          </TabList>
        </TabGroup>
      </div>
    </Container>
  );
}
